import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';

import { DepositTableRow } from '@connect-services/client/services/management-data.service';
import { Deposit } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-deposit-list-status',
    templateUrl: './deposit-list-status.component.html',
})
export class DepositListStatusComponent {
    public readonly deposit: InputSignal<DepositTableRow | undefined> = input<DepositTableRow>();
    public readonly hasStandard: InputSignal<boolean> = input.required();
    public readonly isValid: InputSignal<boolean> = input.required<boolean>();

    protected readonly Deposit = Deposit;
    protected readonly status: Signal<Deposit.StatusEnum | undefined> = computed(() => this.deposit()?.status);
}
